import { render, staticRenderFns } from "./AltriFiles.vue?vue&type=template&id=0adf7002&scoped=true"
import script from "./AltriFiles.vue?vue&type=script&lang=js"
export * from "./AltriFiles.vue?vue&type=script&lang=js"
import style0 from "./AltriFiles.vue?vue&type=style&index=0&id=0adf7002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adf7002",
  null
  
)

export default component.exports